export default {
  // -activityflash---------------
  metaTitle: '闪购报名',
  pageTitle: '活动报名',
  content: '当前报名类型和规格为',
  flashsale: '闪购报名',
  placeholder1: 'Listing#',
  placeholder2: 'Sku#',
  placeholder3: 'Listing标题',
  placeholder4: '店内分类',
  placeholder5: '选择上架时间',
  filter: '过滤',
  submitBtn: '提交申请',
  buttonName: '平台类目',
  buttonName2: '平台类目',
  columns1: '全选',
  columns2: 'Listing ID',
  columns3: '标题',
  columns4: '最低商品价',
  columns5: '最高商品价',
  columns6: '可售sku数',
  sessions1: '上午场',
  sessions2: '下午场',
  sessions3: '午夜场',
  // ---activitypromotion----------------------------
  metaTitle2: '团购活动报名',
  promotion: '活动(满减)',
  confirmContent: '您确认要执行吗',
  // ---activitygroup------------------------------
  metaTitle1: '团购报名',
  main1: '团购',
  main2: '天有效期',
  main3: '成团人数',
  main4: '在',
  main5: '小时后过期',
  main6: '期望开始时间',
  // ----activitytd---------------------
  metaTitle3: '限时折扣报名',
  today1: '限时折扣',
  today2: '天数',

  startTime: '上架开始日期',
  endTime: '上架结束日期',
  actSubTitle: '大促活动报名',
  setPriceLJ: '立减',
  batchPriceSetting: '大促价格批量设置',

  discountLowestTips: '价格折扣超过50%，确定报名吗？',
  discountLowestTitle: '价格风险提示',

  setPriceLabel1: '统一定价',
  setPriceLabel2: '统一减价',
  setPriceLabel3: '统一加价',
  setPriceLabel4: '统一折扣',
  submit: '确定价格设置并报名',

  subRegTips: '是否确定提交报名?',
  subRegTipsTitle: '提示',
  confirm: '确认',
  cancel: '取消',
  submitOk: '提交成功',
  submitBtnText: '提交报名',

  regNameAndType: '当前报名类型和规格为：',

  selectType: '请选择',
  setPriceTips: '只可输入整数, 输入80, 等于降价80%；假如输入小数80.9，改价时还是会以减价80%为准',
  setPriceTips1: '在销售价上加减数值，比如 -10 表示对所有报名商品SKU减-10作为活动价',
  setPriceTips2: '所有报名商品SKU都被设置为指定价格， 请谨慎选择此项',
  priceNullTips: '请输入所有SKU的活动价',

  historyPriceLabel: '历史最低价',
  historyPriceTips: '30天内最低成交价(不包含秒杀价)',

  imageLabel: '图片',
  skuInfoLabel: 'SKU信息',
  titleLabel: '标题',
  salePriceLabel: '销售价(KSh)',
  dealPriceLabel: '交易价格(KSh)',
  operationLabel: '操作'
}
